import styled from "styled-components";
import { GRAY_LIGHT, TEXT_SECONDARY } from "@streeteasy/design-system/colors";
import { Caption } from "@streeteasy/design-system/typography/Typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const LicenseText = styled(Caption).attrs({
  type: "disclaimer"
})`
  color: ${TEXT_SECONDARY};
  padding: 0 16px 16px;

  @media screen and (max-width: ${smallScreen}px) {
    border-top: 1px solid ${GRAY_LIGHT};
    padding: 16px;
    text-align: left;
    width: 100%;
  }
`;
